import {
  getRefreshToken,
  setLocalAccessToken,
  setLocalRefreshToken,
} from "@/lib/storeManager";
import { axiosConfig } from "@/services/axiosConfig";

export type TokenRefreshResult = {
  access: string;
  refresh?: string;
};

export const refreshAuthTokens = async (): Promise<TokenRefreshResult> => {
  const refresh = getRefreshToken()?.trim();
  if (!refresh) {
    throw new Error("Refresh token is required");
  }

  const response = await axiosConfig.post<TokenRefreshResult>(
    "/auth/token-refresh/",
    { refresh }
  );

  const access = response.data?.access?.trim();
  if (!access) {
    throw new Error("Token refresh response missing access token");
  }

  setLocalAccessToken(access);
  axiosConfig.defaults.headers.common.Authorization = `Bearer ${access}`;

  const newRefresh = response.data?.refresh?.trim();
  if (newRefresh) {
    setLocalRefreshToken(newRefresh);
  }

  return {
    access,
    ...(newRefresh ? { refresh: newRefresh } : {}),
  };
};
